import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./NavBar.css";

export default function NavBar({ partner = false }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
    setMobileMenuOpen(false); // Close mobile menu if open
  };

  return (
    <header className={`navbar ${partner ? "navbar-partner" : ""}`}>
      <div className="navbar-logo" onClick={handleLogoClick} style={{ cursor: "pointer" }}>
        <span className="logo-trial">
            <span className="logo-cure">CURE</span>
            {/* <FaHeart className="logo-heart" /> */}
            <span className="logo-iosity">IOSITY</span>
        </span>
      </div>

      {!partner && (
        <nav className={`navbar-links ${mobileMenuOpen ? "mobile-open" : ""}`}>
          <NavLink
            to="/FORYOU"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setMobileMenuOpen(false)}
          >
            For You
          </NavLink>
          <NavLink
            to="/favorites"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setMobileMenuOpen(false)}
          >
            Favorites
          </NavLink>
          <NavLink
            to="/profile"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setMobileMenuOpen(false)}
          >
            Profile
          </NavLink>
        </nav>
      )}

      {!partner && (
        <button
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          {mobileMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
      )}
    </header>
  );
}
